import { Sector } from "../typesExtendedReport";

export type PmrBucket = { projectCount: number; percent: number };

export type SectorView = {
    region: string;
    data: Record<string, number>;
    projectCounts?: Record<string, number>;
};

export const safeNum = (v: unknown, d = 0) =>
    Number.isFinite(Number(v)) ? Number(v) : d;

export function transformSectors(sectors: Sector[] = []): SectorView[] {
    return sectors.map((s) => {
        const { amounts, counts } = (s.divisions ?? []).reduce(
            (acc, d: any) => {
                const key = d.divisionAcronym;
                acc.amounts[key] = safeNum(d.divisionAmount ?? d.divisionAmout);
                acc.counts[key] = safeNum(
                    d.divisionProjectCount ?? d.projectsCount ?? 0
                );
                return acc;
            },
            { amounts: {} as Record<string, number>, counts: {} as Record<string, number> }
        );

        return {
            region: s.sectorAcronym,
            data: amounts,
            projectCounts: counts,
        };
    });
}

export function pmrToArrayRaw(
    pmr?: Record<string, PmrBucket> | null
): PmrBucket[] {
    if (!pmr || typeof pmr !== 'object') return [];

    const order = ['success', 'succes', 'alert', 'problem', 'na'];
    const used = new Set<string>();
    const arr: PmrBucket[] = [];

    for (const key of order) {
        if (pmr[key] && !used.has(key)) {
            arr.push(pmr[key]);
            used.add(key);
        }
    }

    for (const [k, v] of Object.entries(pmr)) {
        if (!used.has(k)) arr.push(v as PmrBucket);
    }

    return arr;
}